import React from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";
import TextField from "@mui/material/TextField";

const DebouncedTextField = ({ delay, onChange, ...textFieldProps }) => {
  const debouncedOnChange = debounce(onChange, delay);
  const handleChange = (e) => debouncedOnChange(e.target.value);

  return <TextField onChange={handleChange} {...textFieldProps} />;
};

DebouncedTextField.defaultProps = {
  delay: 0,
};

DebouncedTextField.propTypes = {
  delay: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DebouncedTextField;
